export default __webpack_public_path__ + "static/gb-nir-a7195b4c0984dee9ce0ff3daa640e613.svg";